import ReactECharts from "echarts-for-react";
import useApi from "../../api";
import { useEffect, useState } from "react";
import {  SelectOptionType } from "../common";
import SelectStyled from "../Select";
import { handleRetriveError } from "../../utils";

function SummaryChart() {
  const [selectedOption, setSelectedOption] = useState<string | null>(
    "week"
  );
  const [orderSummery, setOrderSummery] = useState<any>([]);
  const titleOrderSummery = orderSummery.map((item: [string, number]) => item[0]);
  const api = useApi();

  const handleOptionChange = (value: any) => {
    setSelectedOption(value.value);
  };

 
  const options: SelectOptionType[] = [
    { value: "all-time", label: "All time" },
    { value: "year", label: "Year" },
    { value: "month", label: "Month" },
    { value: "week", label: "Week" },
    { value: "day", label: "Day" },
  ];


  useEffect(() => {
    const queryparams = {
      time_period: selectedOption,
    }
    api.getOrderSummary(queryparams).then((response) => {
      setOrderSummery(response);
    },handleRetriveError);
  }, [selectedOption]);

  const getMaxValue = () => {
    const digitList = orderSummery.map((item: [string, number]) => Math.floor(Number(item[1])));
    return Math.max(...digitList) * 1.20; // 20% more than the max value
  };

  const option = {
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: titleOrderSummery,
    },
    yAxis: {
      type: "value",
      boundaryGap: [0, "50%"],
      max: getMaxValue(),
    },
    visualMap: {
      type: "piecewise",
      show: false,
      dimension: 0,
      seriesIndex: 0,
      pieces: [
        {
          gt: 1,
          lt: 2,
          color: "#277200",
        },
      ],
    },
    series: [
      {
        type: "line",
        smooth: 0.3,
        symbol: "",
        symbolSize: 4,
        lineStyle: {
          color: "#277200",
          width: 2,
        },
        itemStyle: {
          borderWidth: 5,
          borderColor: "#277200",
          color: "white",
        },
        areaStyle: {},
        data: orderSummery,
      },
    ],
  };
  

  return (
      <div className="lg:w-[100%] border border-[#EEEFF2] rounded-xl my-5">
            <div className="pt-5 px-3 mb-[-20px] flex justify-between items-center">
          <h4 className="font-nunito font-nunito-h1 text-2xl">Statistics</h4>

          <SelectStyled
            options={options}
            defaultValue={{ value: "week", label: "Week" }}
            onChange={handleOptionChange}
            className="w-[100px] text-sm text-base-300 bg-secondary-50 border border-[#EEEFF2] shadow-sm z-10"
          />
        </div>
        <ReactECharts option={option} style={{ height: "500px", width: "100%" }} />
      </div>
  )

;
}

export default SummaryChart;
